import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { StaticDataEffects } from './static-data.effects';

@NgModule({ declarations: [], imports: [CommonModule, EffectsModule.forFeature([StaticDataEffects])], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class StaticDataModule {}
